import { html, LitElement } from 'lit';
import { ToujouStorageBehaviour } from '../../../mixins/toujou-storage-behaviour.js';

class ToujouFavToggle extends ToujouStorageBehaviour(LitElement) {
  static get is() {
    return 'toujou-fav-toggle';
  }

  static get properties() {
    return {
      code: {
        type: String,
      },

      faved: {
        type: Boolean,
      },
    };
  }

  constructor() {
    super();
    this.faved = false;
    this.addEventListener('click', this.toggle);
  }

  connectedCallback() {
    super.connectedCallback();
    this.initialized = true;
  }

  render() {
    return html`
      ${this.faved
    ? html`<slot name="faved-content"></slot>`
    : html`<slot name="unfaved-content"></slot>`}
    `;
  }

  set storageValue(favList) {
    this.favList = favList || [];
    this.faved = this.code ? this.favList.includes(this.code) : null;
  }

  toggle(event) {
    if (event instanceof Event) {
      event.preventDefault();
    }

    const index = this.favList.indexOf(this.code);
    if (index === -1) {
      this.favList.push(this.code);
      this.saveStorageValue(this.favList);
    } else if (index >= 0) {
      this.favList.splice(index, 1);
      this.saveStorageValue(this.favList);
    }
  }
}

customElements.define(ToujouFavToggle.is, ToujouFavToggle);
